module.exports = __webpack_public_path__ + "static/img/12.e322d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/12.png
// module id = O0LI
// module chunks = 0